import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { IconButton, Stack, Tooltip } from "@mui/material";
import { PropsWithChildren, ReactElement, ReactNode } from "react";
import { FaIcon } from "../../DataDisplay/Icon/FaIcon";

export function SrIconButtonGroup({ children }: PropsWithChildren): ReactElement {
  return (
    <Stack
      sx={{
        flexDirection: "row",
        justifyContent: "flex-end",
        gap: 2,
        borderRadius: 0.5,
        border: "1px solid",
        borderColor: "stroke.transparentDim",
        backdropFilter: "blur(5.5px)",
        px: 2,
        py: 0.5,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </Stack>
  );
}

SrIconButtonGroup.Item = Item;

export type SrIconButtonGroupItemProps = Readonly<{
  icon: IconDefinition;
  selected?: boolean;
  disabled?: boolean;
  tooltipAvailable?: ReactNode;
  tooltipUnavailable?: ReactNode;
  tooltipDisablePortal?: boolean;
  "aria-label"?: string;
  onClick?(): void;
}>;

function Item({
  icon,
  selected,
  disabled,
  tooltipAvailable,
  tooltipUnavailable,
  tooltipDisablePortal,
  "aria-label": ariaLabel,
  onClick,
}: SrIconButtonGroupItemProps) {
  return (
    <Tooltip
      title={disabled ? tooltipUnavailable : tooltipAvailable}
      slotProps={{ popper: { disablePortal: tooltipDisablePortal } }}
    >
      <div>
        <IconButton
          aria-label={ariaLabel ?? "toggle overlay"}
          onClick={!disabled ? onClick : undefined}
          disabled={disabled}
          sx={{
            borderRadius: 0.5,
            padding: 0.875,
            color: selected ? "stroke.active" : "text.secondary",
          }}
        >
          <FaIcon icon={icon} />
        </IconButton>
      </div>
    </Tooltip>
  );
}
